import { CognitoUserPool, CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js'
import Cookies from 'universal-cookie'
import { POOL_DATA_CLIENT, POOL_DATA_COMPANY } from '@/env'

const userPool = new CognitoUserPool(POOL_DATA_CLIENT)

export const signUp = (username: string, email: string, password: string, juid: string) => {
  return new Promise((resolve, reject) => {
    const usernameRegex = /^[a-zA-Z0-9._-]+$/ // ✅ Allow letters, numbers, ., _, and -
    if (!usernameRegex.test(username)) {
      return reject(
        new Error('Username can only contain letters, numbers, dots, underscores, and dashes.')
      )
    }
    const attributeList = [
      new CognitoUserAttribute({ Name: 'email', Value: email }), // ✅ Correct way to pass attributes
      new CognitoUserAttribute({ Name: 'custom:juid', Value: juid }),
      new CognitoUserAttribute({ Name: 'custom:isPasswordChanged', Value: '0' }),
    ]

    // const secretHash = generateSecretHash(username);

    userPool.signUp(
      username,
      password,
      attributeList,
      [
        // { Name: "SECRET_HASH", Value: secretHash }
      ],
      (err, result) => {
        if (err) {
          console.log(err)

          reject(err)
        } else {
          resolve(result)
          console.log(err)
        }
      }
    )
  })
}

export const confirmSignUp = (username: string, code: string) => {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: username, Pool: userPool })

    user.confirmRegistration(code, true, (err, result) => {
      if (err) {
        reject(err)
        console.log(err)
      } else {
        resolve(result)
        console.log(err)
      }
    })
  })
}

const adminPool = new CognitoUserPool(POOL_DATA_COMPANY)

export const signUpAdmin = (username: string, email: string, password: string) => {
  return new Promise((resolve, reject) => {
    const usernameRegex = /^[a-zA-Z0-9._-]+$/ // ✅ Allow letters, numbers, ., _, and -
    if (!usernameRegex.test(username)) {
      return reject(
        new Error('Username can only contain letters, numbers, dots, underscores, and dashes.')
      )
    }
    const attributeList = [
      new CognitoUserAttribute({ Name: 'email', Value: email }), // ✅ Correct way to pass attributes
      new CognitoUserAttribute({ Name: 'custom:isPasswordChanged', Value: '0' }),
    ]

    // const secretHash = generateSecretHash(username);

    adminPool.signUp(username, password, attributeList, [], (err, result) => {
      if (err) {
        console.log(err)

        reject(err)
      } else {
        resolve(result)
        console.log(err)
      }
    })
  })
}

export const confirmSignUpAdmin = (username: string, code: string) => {
  return new Promise((resolve, reject) => {
    const admin = new CognitoUser({ Username: username, Pool: adminPool })

    admin.confirmRegistration(code, true, (err, result) => {
      if (err) {
        reject(err)
        console.log(err)
      } else {
        resolve(result)
        console.log(err)
      }
    })
  })
}
